import { render, staticRenderFns } from "./bedForm.vue?vue&type=template&id=6885b0bb&scoped=true&"
import script from "./bedForm.vue?vue&type=script&lang=js&"
export * from "./bedForm.vue?vue&type=script&lang=js&"
import style0 from "./bedForm.vue?vue&type=style&index=0&id=6885b0bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6885b0bb",
  null
  
)

export default component.exports